import { MultipleQueriesQuery } from "@algolia/client-search";
import algoliasearch, { AlgoliaSearchOptions } from "algoliasearch/lite";
import settings from "./mergeSettings";
import strings from "./strings";



//export const APPOINTMENT_URL = `${settings.onlineDomain}/Login/LoginForAppointment.aspx`;
export const APPOINTMENT_URL = `${settings.onlineDomain}`;


export const SERACH_DOCTORS_API = '/api/search/';

export const pages = {
  globalSearchResults: "globalSearchResults",
  doctorsInBranch: "doctorsInBranch",
  searchDoctors: "searchDoctors",
  doctorsSearchResults: "doctorsSearchResults",
  searchDiet: "searchDiet",
  dietSerachResults: "dietSearchResults",
  searchSocialWorker: "searchSocialWorker",
  socialWorkerSearchResults: "socialWorkerSearchResults",
  searchMedicalCenters: "searchMedicalCenter",
  medicalCentersSearchResults: "medicalcenterSearchResults",
  searchEmergency: "searchEmergency",
  emergencySearchResults: "emergencySearchResults",
  searchWomenEmergency: "searchWomenEmergency",
  womenEmergencySearchResults: "womenEmergencySearchResults",
  searchOptica: "searchOptica",
  opticaSearchResults: "opticaSearchResults",
  searchPharmacy: "searchPharmacy",
  pharmacySearchResults: "pharmacySearchResults",
  searchTeeth: "searchDental",
  teethSearchResults: "dentalSearchResults",
  searchOuterService: "searchOuterService",
  outerServiceSearchResults: "outerServiceSearchResults",
  searchOperations: "searchOperations",
  operationsSearchResults: "operationsSearchResults",
  medicinesPage: "mediciences",
  entitlementPage: "entitlement",
  entitlementFieldLobby: "entitlementFieldLobby",
  globalSearchResultsAutoSuggest: "globalSearchResultsAutoSuggest",
};

export const availablePages = [
  pages.globalSearchResults,
  pages.doctorsInBranch,
  pages.searchDoctors,
  pages.doctorsSearchResults,
  pages.searchDiet,
  pages.dietSerachResults,
  pages.searchSocialWorker,
  pages.socialWorkerSearchResults,
  pages.searchMedicalCenters,
  pages.medicalCentersSearchResults,
  pages.searchEmergency,
  pages.emergencySearchResults,
  pages.searchWomenEmergency,
  pages.womenEmergencySearchResults,
  pages.searchOptica,
  pages.opticaSearchResults,
  pages.searchPharmacy,
  pages.pharmacySearchResults,
  pages.searchTeeth,
  pages.teethSearchResults,
  pages.searchOuterService,
  pages.outerServiceSearchResults,
  pages.searchOperations,
  pages.operationsSearchResults,
  pages.medicinesPage,
  pages.entitlementPage,
  pages.entitlementFieldLobby,
  pages.globalSearchResultsAutoSuggest
];

export const SITE_INDEX_HE = "SITE_INDEX_HE";
export const DOCTORS = "DOCTORS_INDEX";
export const DOCTORS_SORT = "DOCTORS_INDEX_SORT";
export const MEDICALCENTERS = "MEDICALCENTERS_INDEX";
export const MEDICALCENTERS_SORT = "MEDICALCENTERS_INDEX_SORT";
export const SHABAN = "SHABAN_INDEX";
export const SHABAN_SORT = "SHABAN_INDEX_SORT";
export const MEDICINES = "MEDICINES_INDEX";
export const ZAKAUT = "ZAKAUT_INDEX";

const algoliaRouting: AlgoliaSearchOptions = {
  hosts: [{ url: settings.searchApiUrl }],
  timeouts:{
    connect: 20,
    read: 20,
    write: 60
  }
};

export const searchClient = settings.searchApiUrl == "" ?
  algoliasearch(
    "00S7Y4XT5Q",
    "15b104b27ba2bc2b213b69f3188945e7"
  ) :
  algoliasearch(
    "00000",
    "0000000",
    algoliaRouting
  );

// Define the type for the search client
// interface CustomSearchClient extends SearchClient {
//   search: (requests: any) => Promise<any>;
// }

export const leumitSearchClient = {
  ...searchClient,
  async search<TObject>(requests: readonly MultipleQueriesQuery[]) {
    const hasFacetFilters =
      requests.length > 0 &&
      requests[0].params?.facetFilters &&
      Array.isArray(requests[0].params.facetFilters) &&
      requests[0].params.facetFilters.length > (requests[0].indexName === DOCTORS ? 1 : 0);

    const hasFilters =
      requests.length > 0 &&
      requests[0].params?.filters &&
      requests[0].params.filters.length > 0;

    if (!requests[0]?.params?.query && !hasFacetFilters && !hasFilters) {
      return Promise.resolve({
        results: requests.map(() => ({
          hits: [],
          nbHits: 0,
          nbPages: 0,
          page: 0,
          processingTimeMS: 0,
          hitsPerPage: 0,
          exhaustiveNbHits: false,
          query: "",
          params: ""
        }))
      });
    }

    try {
      return await searchClient.search<TObject>(requests);
    } catch (error: any) {
      if (error.message.includes("Unreachable hosts - your application id may be incorrect")) {
        return {
          results: requests.map(() => ({
            hits: [],
            nbHits: 0,
            nbPages: 0,
            page: 0,
            processingTimeMS: 0,
            hitsPerPage: 0,
            exhaustiveNbHits: false,
            query: "",
            params: "",
            // custom property to signal error
            __isError: true,
            __errorStatus: 403
          }))
        };
      }

      throw error; // let other errors bubble up
    }
  }
}


export const leumitSearchClientGlobal = {
  ...searchClient,
  search<TObject>(requests: readonly MultipleQueriesQuery[]) {   
    if ((requests[0].params?.query?.length ?? 0 < 2)) {
      //if (requests.every(({ params }) => !params?.query)) {
      return Promise.resolve({
        results: requests.map(() => ({
          hits: [],
          nbHits: 0,
          nbPages: 0,
          page: 0,
          processingTimeMS: 0,
          hitsPerPage: 0,
          exhaustiveNbHits: false,
          query: "",
          params: ""
        }))
      });
    }
    return searchClient.search<TObject>(requests);
  }
}

export const LeumitDoctor = "LeumitDoctor";
export const MashlimDoctor = "ExternalDoctor";
export const grad1 = "#dd4081";
export const grad2 = "#523e83";

export const algoliaAttributes = {
  Type: "type",
  Gender: "gender",
  MedicalFieldName: "medicalFieldName",
  SubMdicalFieldName: "subMedicalFieldNames",
  CityCode: "medicalCenter.cityCode",
  DoctorSpecializations: "doctorSpecializations",
  medicalCityCode: "cityCode",
  City: "medicalCenter.city",
  Distance: "distance",
  FirstName: "firstName",
  LastName: "lastName",
  FullName: "fullName",
  Doctors: "doctors",
  Name: "name",
  DaysOfWeek: "medicalCenter.workHours.dayOfWeek",
  WorkHours: "medicalCenter.workHours.timeOfDay",
  Languages: "languages",
  DoctorType: "doctorType",
  ExternalDoctorType: "externalDoctorType",
  ServiceProviderName: "serviceProviderName",
  PlaceDaysOfWeek: "workingHours.dayOfWeek",
  PlaceTimeOfDay: "workingHours.timeOfDay",
  PlaceCity: "city",
  MedicalServices: "medicalServices",
  GroupName: "groupName",
  GroupCode: "groupCode",
  OperationName: "operationName",
  OperationCode: "operationCode",
  SurgeonIsKupa: "surgeonIsKupa",
  AddressCity: "address.city",
  SurgeOnIsKupa: "surgeonIsKupa",
  AddressCityCode: "address.cityCode",
};

export const localAttributes = {
  localMedicalApiKey: "medicalfields",
  localMedicalServicesApiKey: "medicalServices",
  localCitiesApiKey: "cities",
  localDoctorNamesApiKey: "names",
  localMedicalFieldName: "medicalFieldName",
  localSubMedicalFieldNames: "subMedicalFieldNames",
  localDoctorFieldName: "fullName",
  localOuterServiceName: "name",
  localOuterServiceQuery: "query",
  localWorkHoursFieldName: "times",
  localLanguagesFieldName: "lang",
  localCityCodeFieldName: "cityCode",
  localLocFieldName: "loc",
  localRadiusFieldName: "r",
  localdaysOfWeekFieldName: "workday",
  localServiceCodeFieldName: "serviceCode",
  localOperationGroupFieldName: "groupCode",
  localOperationGroupNameApiKey: "group",
  localOperationNameApiKey: "name",
  localOperationNameFieldName: "operationName",
  localOperationCodeApiKey: "code",
  localOperationCodeFieldName: "operationCode",
}

export const doctorGenderOptions =
  [
    {
      label: strings.globalStrings.female,
      value: "נ"
    },
    {
      label: strings.globalStrings.male,
      value: "ז"
    },
  ];

  export const isEmergencyOptions = [
    {
      label: strings.globalStrings.serviceToday,
      value: 'true'
    },
  ];
export const visitDaysOptions = [
  {
    label: strings.globalStrings.sunday,
    value: 'א'
  },
  {
    label: strings.globalStrings.monday,
    value: 'ב'
  },
  {
    label: strings.globalStrings.tuesday,
    value: 'ג'
  },
  {
    label: strings.globalStrings.wednsday,
    value: 'ד'
  },
  {
    label: strings.globalStrings.thursady,
    value: 'ה'
  },
  {
    label: strings.globalStrings.friday,
    value: 'ו'
  }, {
    label: strings.globalStrings.sturday,
    value: 'ש'
  }
];

export const visitDaysOptionsAriaLabel = ['יום א', 'יום ב', 'יום ג', 'יום ד', 'יום ה', 'יום ו', 'יום ש'];

export const visitHoursOptions = [
  {
    label: strings.globalStrings.morning,
    value: 'Morning'
  },
  {
    label: strings.globalStrings.noon,
    value: 'Noon'
  },
  {
    label: strings.globalStrings.evening,
    value: 'Evening'
  }
];

export const languagesOptions = [
  {
    label: strings.globalStrings.arabic,
    value: 'ערבית'
  },
  {
    label: strings.globalStrings.english,
    value: 'אנגלית'
  },
  {
    label: strings.globalStrings.rusian,
    value: 'רוסית'
  }
];

export const aroundRadiusOptions = [
  {
    label: '5 ק"מ',
    value: 5000,
    isSelected: false
  }, 
  {
    label: '10 ק"מ',
    value: 10000,
    isSelected: true
  },
  {
   label: '15 ק"מ' ,
    value: 15000,
    isSelected: false
   
  },
  {
    label: '20 ק"מ',
    value: 20000,
    isSelected: false
  },
];

export const hearingCategories = ['Basic', 'Silver', 'Gold'];

export const globalSearchIndexes = [
  {
    key: 'Shaban',
    value: strings.globalSearchResults.shaban
  },
  {
    key: 'Doctor',
    value: strings.globalSearchResults.doctors
  },
  {
    key: 'OuterService',
    value: strings.globalSearchResults.outerServices
  },
  {
    key: 'Medicine',
    value: strings.globalSearchResults.medicines
  },
  {
    key: 'Dental',
    value: strings.globalSearchResults.dental
  },
  {
    key: 'Zakaut',
    value: strings.globalSearchResults.entitlement
  },
  {
    key: 'Pharmacy',
    value: strings.globalSearchResults.pharamcies
  },
  {
    key: 'Optica',
    value: strings.globalSearchResults.optica
  },
  {
    key: 'Emergency',
    value: strings.globalSearchResults.emergency
  },
  {
    key: 'Diet',
    value: strings.globalSearchResults.diet
  },
  {
    key: 'SocialWorker',
    value: strings.globalSearchResults.socialWorkers
  },
  {
    key: 'WomenEmergency',
    value: strings.globalSearchResults.emergencyWomen
  },
  {
    key: 'LeumitMedicalCenter',
    value: strings.globalSearchResults.medicalCenters
  },
  {
    key: 'Page',
    value: strings.globalSearchResults.articlesAndDocuments
  }
];

export const indexesPages = [
  {
    objectType: 'Dental',
    url: settings.dentalPage
  },
  {
    objectType: 'Diet',
    url: settings.dietPage
  },
  {
    objectType: 'Doctor',
    url: settings.doctorPage
  },
  {
    objectType: 'Emergency',
    url: settings.emergencyPage
  },
  {
    objectType: 'LeumitMedicalCenter',
    url: settings.medicalCenterPage
  },
  {
    objectType: 'Optica',
    url: settings.opticaPage
  },
  {
    objectType: 'OuterService',
    url: settings.outerServicePage
  },
  {
    objectType: 'Shaban',
    url: settings.operationsSearchResults
  },
  {
    objectType: 'SocialWorker',
    url: settings.socialWorkerPage
  }, 
  {
    objectType: 'Pharmacy',
    url: settings.pharmacyPage
  },
  {
    objectType: 'Zakaut',
    url: settings.zakautServicePage
  }, 
  {
    objectType: 'Medicine',
    url: settings.medicienceSearchResults
  },
];

export const searchIndexes = [
  {
    objectType: 'Doctor',
    url: settings.doctorSearchResults
  },
  {
    objectType: 'Diet',
    url: settings.dietSearchResults
  }, 
  {
    objectType: 'SocialWorker',
    url: settings.socialWorkerSearchResults
  },
  {
    objectType: 'WomenEmergency',
    url: settings.womenEmergencySearchResults
  },
  {
    objectType: 'Emergency',
    url: settings.emergencySearchResults
  },
  {
    objectType: 'Optica',
    url: settings.opticaSearchResults
  },
  {
    objectType: 'Medicine',
    url: settings.medicienceSearchResults
  },
  {
    objectType: 'all',
    url: settings.globalSearchResults
  }   
];




